export function removeEntrySpinner() {
  const element = document.getElementById("entry-spinner");
  if (element?.parentNode) {
    element.parentNode.removeChild(element);
  }
}
